import { render, staticRenderFns } from "./OrderCargoList.vue?vue&type=template&id=5338f9c9&"
import script from "./OrderCargoList.vue?vue&type=script&lang=js&"
export * from "./OrderCargoList.vue?vue&type=script&lang=js&"
import style0 from "./OrderCargoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports